module.exports = __webpack_public_path__ + "img/Weapon_31.47bc1011.png";